import { Box, Text } from '@chakra-ui/react'
import { ItListItem } from 'types/graphql'

import { useFormContext } from '@redwoodjs/forms'

import documentPlaceholder from 'src/assets/image/placeholder-pdf.jpg'
import EditItemImage from 'src/components/widgets/EditItemImage/EditItemImage'
import ErrorMessage from 'src/components/widgets/ErrorMessage/ErrorMessage'
import Input from 'src/components/widgets/Input/Input'
import VoiceTipRecorder from 'src/components/widgets/VoiceTipRecorder/VoiceTipRecorder'
import { MAX_LG_INPUT, MAX_LG_INPUT_NO_COUNTER } from 'src/lib/constants'

import { TypeBuilderProps } from '../..'
import OnlyAvailableOnItList from '../../OnlyAvailableOnItList/OnlyAvailableOnItList'
import Uploader from '../../Uploader/Uploader'
import useUploader from '../../Uploader/useUploader'

const Body: React.FC<
  Pick<TypeBuilderProps, 'voiceTipRecorderProps' | 'itemId'>
> = ({ voiceTipRecorderProps, itemId }) => {
  return (
    <Box mt={4} w="full">
      <Text as="h5" className="thick" mt={12} mb={4}>
        About this PDF
      </Text>
      <Input
        w="full"
        name="title"
        placeholder="Title"
        data-testid="builder-documentTitle"
        clearable
        withCounter={true}
        maxLength={MAX_LG_INPUT}
        hideCounterMax={MAX_LG_INPUT_NO_COUNTER}
      />
      <EditItemImage
        name="document.coverUrl"
        borderRadius={12}
        assetType="itListItemCover"
        assetId={itemId}
        width={350}
        height={350}
        title="Thumbnail"
        hint="Optional"
        placeholderSrc={documentPlaceholder}
      />
      <VoiceTipRecorder
        name="hasVoiceTip"
        mt={4}
        title="Voice Tip"
        subtitle="Optional"
        showProfileImage={true}
        {...voiceTipRecorderProps}
      />
      <Text color="stone" mb={4} mt={2} className="body-extra-small">
        Helpful context boosts conversions.
      </Text>
      <OnlyAvailableOnItList name="document.onlyAvailableOnItList" />
    </Box>
  )
}

const Builder: React.FC<TypeBuilderProps> = ({
  voiceTipRecorderProps,
  itemId,
}) => {
  const { onChange, ...uploader } = useUploader()
  const {
    getValues,
    formState: { errors },
  } = useFormContext<ItListItem>()
  const hasValues =
    getValues('hasVoiceTip') ||
    getValues('document.coverUrl') ||
    getValues('title')

  return (
    <Box>
      <Uploader accept=".pdf" {...uploader} onUpload={onChange} />
      {errors?.document?.fileName && (
        <ErrorMessage mt={2} message="Document required" />
      )}
      {(uploader.isDirty || hasValues) && (
        <Body voiceTipRecorderProps={voiceTipRecorderProps} itemId={itemId} />
      )}
    </Box>
  )
}

export default Builder
